import { AfterViewInit, Component, inject, OnInit, signal } from '@angular/core';
import { BrandContainerComponent } from '../components/brand-container/brand-container.component';
import { TrainingService } from '../training.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: true,
  imports: [BrandContainerComponent, RouterModule],
  host: {
    class: 'page-not-found'
  }
})
export class PageNotFoundComponent implements OnInit, AfterViewInit {
  trainingService = inject(TrainingService);

  collapsed = signal(true);
  config = signal(null);

  ngOnInit(): void {
    this.collapsed.set(true);
  }

  ngAfterViewInit() {
    this.trainingService.loadConfig().then((config) => {
      this.config.set(config);
    });
  }

  toggleCollapsed(): void {
    this.collapsed.update((value) => !value);
  }
}
